import { render, staticRenderFns } from "./TrappedGrape.vue?vue&type=template&id=277a8b4d&scoped=true"
import script from "./TrappedGrape.vue?vue&type=script&lang=js"
export * from "./TrappedGrape.vue?vue&type=script&lang=js"
import style0 from "./TrappedGrape.vue?vue&type=style&index=0&id=277a8b4d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277a8b4d",
  null
  
)

export default component.exports